import { styled } from 'mz-ui-kit'


export const PickupTimelineWrapper = styled('div', ({ $plain, $palette }) => {
  return $plain ? {} : {
    marginTop: '20px',
    borderRadius: '3px',
    border: `1px solid ${$palette('primary').setAlpha(0.5)}`,
    background: `${$palette('primary').setAlpha(0.2)}`
  };
});

export const Container = styled('div', {
  margin: '20px'
});
